import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function CoptTable({ data, onEdit }) {
  const columns = [
    {
      title: "COPT System Name",
      dataIndex: "copt_name",
      key: "copt_name",
      align: "center",
    },
    {
      title: "COPT System Maker",
      dataIndex: "copt_maker",
      key: "copt_maker",
      align: "center",
    },
    {
      title: "COPT System Model",
      dataIndex: "copt_model",
      key: "copt_model",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
